/**
 * Estimativas de tempo de processamento NO SERVIDOR (backend sinc-api / TB_OUTBOX + Hangfire).
 * O front NÃO recebe confirmação do servidor (não há endpoint de status — backlog do plano
 * mestre): tudo aqui alimenta TEXTO DE ESTIMATIVA, nunca "confirmado".
 *
 * FONTE: TB_OUTBOX, últimos 14 dias, medido em 2026-10-18.
 *  - 09h-15h BRT: mediana (p50) 4-6,5 min · p95 9-18 min
 *  - 21h BRT: p50 9 min · p95 49 min (bug conhecido do backend, no backlog — NÃO modelado aqui)
 *  - pausa noturna: 02h-06h BRT (texto aprovado; o job de reprocesso do backend usa 5h-8h UTC)
 * Se o backend mudar (cadência do Hangfire, fix das 21h), ATUALIZE estas constantes e a data.
 */
export const ESTIMATES_MEASURED_AT = '2026-10-18'
export const ESTIMATES_SOURCE = 'TB_OUTBOX, últimos 14 dias'

/** "normalmente 2–7 min" (texto aprovado). */
export const PROCESSING_TYPICAL_MIN: readonly [number, number] = [2, 7]
/** "no pico pode passar de 15 min". */
export const PROCESSING_PEAK_MIN = 15
/** Depois disto (já descontada a pausa) assume-se processado — ainda como ESTIMATIVA. */
export const PROCESSING_ASSUME_DONE_MIN = 60
/** "pausado das 02h às 06h" (BRT). */
export const SERVER_PAUSE_BRT = { startHour: 2, endHour: 6 } as const
/** Ciclo do push automático (SLEEP_TIME de syncWorker.js = 30 s). */
export const SYNC_AUTO_PUSH_SECONDS = 30

/** Brasília = UTC-3 fixo (sem horário de verão desde 2019). Teste-guarda compara com Intl. */
export const BRT_OFFSET_HOURS = -3

const HOUR = 60 * 60 * 1000
const DAY = 24 * HOUR
const shifted = (ms: number) => ms + BRT_OFFSET_HOURS * HOUR

export const brtHour = (ms: number): number =>
  new Date(shifted(ms)).getUTCHours()

export const isServerPaused = (ms: number): boolean => {
  const h = brtHour(ms)
  return h >= SERVER_PAUSE_BRT.startHour && h < SERVER_PAUSE_BRT.endHour
}

/** Minutos de [from, to] que caem dentro da pausa 02h-06h BRT (soma de todas as noites). */
export function serverPausedMinutesBetween(from: number, to: number): number {
  if (!(to > from)) return 0
  const s = shifted(from)
  const e = shifted(to)
  let total = 0
  for (let day = Math.floor(s / DAY); day <= Math.floor(e / DAY); day++) {
    const ws = day * DAY + SERVER_PAUSE_BRT.startHour * HOUR
    const we = day * DAY + SERVER_PAUSE_BRT.endHour * HOUR
    total += Math.max(0, Math.min(e, we) - Math.max(s, ws))
  }
  return total / 60000
}
